const maxRetries = 3;
let retries = 0;

export type OnMessage = (data: ReturnType<JSON['parse']>) => void;

export function connectWebsocket(authUrl: string, onMessage: OnMessage) {
    if (typeof WebSocket === 'undefined') {
        return Promise.resolve();
    }

    return fetch(authUrl, { credentials: 'same-origin' })
        .then(response => response.json())
        .then(resp => {
            if (!resp || !resp.url) {
                throw new Error('No onsite notifications websocket URL found.');
            }
            initWebsocket(resp.url, authUrl, onMessage);
        })
        .catch(() => {
            retryConnectOnFailure(authUrl, onMessage);
        });
}

function initWebsocket(websocketUrl: string, authUrl: string, onMessage: OnMessage) {
    const websocket = new WebSocket(websocketUrl);
    websocket.onclose = () => {
        retryConnect(authUrl, onMessage);
    };
    websocket.onmessage = e => {
        const messages = e.data.split('\n');
        for (var i = 0; i < messages.length; i++) {
            const data = JSON.parse(messages[i]);
            onMessage(data);
        }
    };
}

function retryConnectOnFailure(authUrl: string, onMessage: OnMessage) {
    if (retries >= maxRetries) {
        return;
    }
    retries += 1;
    retryConnect(authUrl, onMessage);
}

function retryConnect(authUrl: string, onMessage: OnMessage) {
    // randomise reconnect delay between 200ms -> 5000ms
    const rand = Math.round(Math.random() * (5000 - 200)) + 200;
    setTimeout(async () => {
        await connectWebsocket(authUrl, onMessage);
    }, rand);
}
